import { SearchInputSize, SearchInputVarant } from 'omakase/SearchInput/SearchInput';
import { Theme, css } from '@emotion/react';
import { assertNever } from '@tock/shared/utils/typeUtils';

const inputHeightFromSize = (size: SearchInputSize): number => {
  switch (size) {
    case 'xlarge':
      return 56;
    case 'large':
      return 48;
    case 'medium':
      return 44;
    default:
      assertNever(size);
  }
};

export const searchInputBaseStyles = (_theme: Theme, fullWidth: boolean) => {
  return css`
    display: ${fullWidth ? 'flex' : 'inline-flex'};
    position: relative;
    width: ${fullWidth ? '100%' : 'auto'};
  `;
};

export const getBorderColorsFromVariant = (
  { colors }: Theme,
  variant: SearchInputVarant
): { borderColorFocused: string; borderColorEnabled: string } => {
  switch (variant) {
    case 'basic':
      return {
        borderColorFocused: colors.borderPrimaryBase,
        borderColorEnabled: colors.borderDefault,
      };
    case 'ghost':
      return {
        borderColorFocused: 'transparent',
        borderColorEnabled: 'transparent',
      };
      break;
  }
};

export const searchInputInputStyles = (
  theme: Theme,
  size: SearchInputSize,
  variant: SearchInputVarant,
  disabled: boolean
) => {
  const height = inputHeightFromSize(size);
  const textColor = disabled ? theme.colors.fgDisabled : 'inherit';
  const { borderColorEnabled, borderColorFocused } = getBorderColorsFromVariant(theme, variant);
  return css`
    -webkit-tap-highlight-color: transparent;
    -webkit-text-fill-color: ${textColor};
    appearance: none;
    background: ${disabled ? theme.colors.bgLighter : theme.colors.bgDefault};
    border-radius: ${height}px;
    border: 1px solid ${borderColorEnabled};
    box-shadow: inset 0 0 0 1px transparent;
    caret-color: ${theme.colors.fgPrimaryBase};
    color: ${textColor};
    display: block;
    height: ${height}px;
    overflow: hidden;
    letter-spacing: inherit;
    margin: 0;
    min-width: 0;
    opacity: 1;
    padding-left: ${inputHeightFromSize(size)}px;
    padding-right: ${inputHeightFromSize(size)}px;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    ${theme.typography.variant('body02')};

    ${theme.interactiveStates.focus(css`
      border-color: ${borderColorFocused};
      box-shadow: inset 0 0 0 1px ${borderColorFocused};
      outline: none;

      & + svg {
        color: ${theme.colors.fgPrimaryBase};
      }
    `)};
  `;
};

export const searchInputSearchIconStyles = (theme: Theme, disabled: boolean, empty: boolean) => css`
  color: ${disabled
    ? theme.colors.fgDisabled
    : empty
      ? theme.colors.fgSubtle
      : theme.colors.fgDefault};
  left: ${theme.spacing(2)}px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;

export const searchInputClearButtonStyles = (theme: Theme) => css`
  position: absolute;
  right: ${theme.spacing(1.5)}px;
  top: 50%;
  transform: translateY(-50%);
`;
